import { render } from "./StatisticsDashboard.vue?vue&type=template&id=780e7404&scoped=true&ts=true"
import script from "./StatisticsDashboard.vue?vue&type=script&lang=ts"
export * from "./StatisticsDashboard.vue?vue&type=script&lang=ts"

import "./StatisticsDashboard.vue?vue&type=style&index=0&id=780e7404&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780e7404"]])

export default __exports__